import React from 'react';
import { Box, Typography } from '@mui/material';
import { hasDishImageUrl } from '../eventImageUtils';

const DEFAULT_SIZE = 56;

const MenuDishImageThumbnail = ({ src, size = DEFAULT_SIZE, borderRadius = 1 }) => {
  if (hasDishImageUrl(src)) {
    return (
      <Box
        component="img"
        src={src}
        alt=""
        loading="lazy"
        sx={{
          width: size,
          height: size,
          borderRadius,
          objectFit: 'cover',
          flexShrink: 0,
          bgcolor: 'grey.100',
          display: 'block',
        }}
      />
    );
  }

  return (
    <Box
      aria-label="No dish image"
      sx={{
        width: size,
        height: size,
        borderRadius,
        flexShrink: 0,
        bgcolor: 'grey.200',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Typography
        component="span"
        sx={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%) rotate(-45deg)',
          color: 'grey.500',
          fontWeight: 700,
          fontSize: '0.5625rem',
          letterSpacing: '0.08em',
          lineHeight: 1,
          userSelect: 'none',
          whiteSpace: 'nowrap',
        }}
      >
        NO IMAGE
      </Typography>
    </Box>
  );
};

export default MenuDishImageThumbnail;
